/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
import * as tocbot from 'tocbot';
import { checkOverflow } from './utils';

function initTOCbot() {
  tocbot.init({
    tocSelector: '#in-page-nav',
    contentSelector: '.js-toc-content',
    headingSelector: 'h2[id]',
    ignoreSelector: '.js-toc-ignore',
    hasInnerContainers: true,
    ignoreHiddenElements: true,
    headingsOffset: 120,
    scrollSmoothOffset: -120,
  });

  // handle sticky nav
  const target = document.querySelector('#in-page-nav-top');
  const mainHeader = document.querySelector('.header');

  if (target) {
    const observer = new IntersectionObserver(
      function (entries) {
        // no intersection with screen
        if (entries[0].intersectionRatio === 0) {
          document.querySelector('#in-page-nav-wrapper').classList.add('is-sticky');
          mainHeader.classList.add('header-dark-green');
        }
        // fully intersects with screen
        else if (entries[0].intersectionRatio === 1) {
          document.querySelector('#in-page-nav-wrapper').classList.remove('is-sticky');
          mainHeader.classList.remove('header-dark-green');
        }
      },
      { threshold: [0, 1] },
    );

    observer.observe(target);
  }
}

// handle mobile
export function handleTOCMobile() {
  const arrow = document.querySelector('.in-page-navigation-wrapper .arrow-down');
  const tocListItems = document.querySelectorAll('.toc-list-item');
  const breakpoint = window.matchMedia('(max-width: 919px)');

  if (!arrow || !tocListItems.length > 0) return;
  let isAllTocListItemsShown = false;

  arrow.addEventListener('click', () => {
    if (!isAllTocListItemsShown) {
      tocListItems.forEach((item) => {
        item.style.display = 'block';
        arrow.classList.add('is-active');
        isAllTocListItemsShown = true;
      });
    } else {
      tocListItems.forEach((item) => {
        item.style.display = '';
        arrow.classList.remove('is-active');
        isAllTocListItemsShown = false;
      });
    }
  });

  tocListItems.forEach((item) => {
    item.addEventListener('click', () => {
      if (breakpoint.matches === true) {
        for (let i = 0; i < tocListItems.length; i += 1) {
          tocListItems[Number(i)].style.display = '';
        }
      }
      arrow.classList.remove('is-active');
      isAllTocListItemsShown = false;
    });
  });

  breakpoint.addEventListener('change', () => {
    if (breakpoint.matches === false) {
      tocListItems.forEach((item) => {
        item.style.display = '';
      });
    }
  });
}

function handleInPageNavOverflow(inPageNav) {
  const arrowLeft = document.querySelector('#in-page-nav-wrapper .arrow-left');
  const arrowRight = document.querySelector('#in-page-nav-wrapper .arrow-right');

  if (!arrowLeft || !arrowRight) return;

  if (checkOverflow(inPageNav)) {
    arrowRight.style.display = 'block';
  } else {
    arrowRight.style.display = '';
  }

  arrowLeft.addEventListener('click', () => {
    inPageNav.scrollBy({
      top: 0,
      left: -500,
      behavior: 'smooth',
    });
  });

  arrowRight.addEventListener('click', () => {
    inPageNav.scrollBy({
      top: 0,
      left: +500,
      behavior: 'smooth',
    });
  });

  inPageNav.addEventListener('scroll', () => {
    const scrollLeftOffset = inPageNav.scrollLeft;

    if (scrollLeftOffset + inPageNav.getBoundingClientRect().width >= inPageNav.scrollWidth) {
      arrowRight.style.display = 'none';
    } else {
      arrowRight.style.display = 'block';
    }
    if (scrollLeftOffset === 0) {
      arrowLeft.style.display = 'none';
    } else {
      arrowLeft.style.display = 'block';
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  const inPageNav = document.querySelector('#in-page-nav');

  if (!inPageNav) return;
  // if there are less than 3 headings remove the in-page nav
  const headings = document.querySelectorAll('h2[id]:not(.visually-hidden)');
  if (headings.length < 3) {
    inPageNav.remove();
    const inPageNavWrapper = document.querySelector('#in-page-nav-wrapper');
    if (inPageNavWrapper) inPageNavWrapper.style.display = 'none';
    return;
  }

  initTOCbot(inPageNav);
  setTimeout(() => {
    handleTOCMobile();
    handleInPageNavOverflow(inPageNav);
  }, 500);

  window.addEventListener('resize', () => {
    handleInPageNavOverflow(inPageNav);
  });
});
